<template>
  <div class="ic-form__email">
    <div class="row my-3" v-if="this.withIntrotext">
      <div class="col-md-4"></div>
      <div class="col-md-8">{{$t(withIntrotext)}}</div>
    </div>

    <IcFormRowWrapper
      id="email"
      name="email"
      :label="$t('label_email')"
      :aria="$t('aria_required')"
      :labelWidth="4"
      :controlWidth="8"
      :showSingleError="true"
    >
      <template slot-scope="{validator}">
        <IcInputEmail
          id="email"
          v-model="data.email"
          :agreement="data.agreement"
          :withAgreement="withAgreement"
          @input="$emit('input', $event); validator.$touch()"
          @agreement:update="$emit('update:agreement', $event)"
        ></IcInputEmail>
      </template>
    </IcFormRowWrapper>

    <IcFormRowWrapper
      v-if="withPolls"
      id="email"
      name="email"
      :labelWidth="4"
      :controlWidth="8"
      :showSingleError="true"
    >
      <template slot-scope="{validator}">
        <fieldset>
        <legend>{{$t('form_email_poll_agreement')}}</legend>
        <IcRadioGroup
          id="email"
          v-model="data.pollAgreement"
          :options="pollOptions"
          @input="$emit('update:pollAgreement', $event)"
        ></IcRadioGroup>
      </fieldset>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
import IcInputEmail from "@/components/ic-common/form/controls/InputEmail";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactEmail",
  props: {
    value: {
      type: String,
      default: ""
    },
    agreement: {
      type: [Number, Boolean],
      default: 0
    },
    withAgreement: {
      type: Boolean,
      default: false
    },
    withPolls: {
      type: Boolean,
      default: false
    },
    withIntrotext: {
      type: [Boolean, String],
      default: "label_email_introtext"
    },
    pollAgreement: {
      default: 0
    }
  },
  data() {
    return {
      pollOptions: [{ id: 1, name: "tak" }, { id: 0, name: "nie" }],
      data: {
        email: this.value,
        agreement: this.agreement,
        pollAgreement: this.pollAgreement
      }
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcInputEmail,
    IcRadioGroup
  }
};
</script>

<style>
</style>
